var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalendarFest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8187",
    "data-name": "Path 8187",
    d: "M13.111,10.8H10.778a.791.791,0,0,0-.778.8V14a.791.791,0,0,0,.778.8h2.333a.791.791,0,0,0,.778-.8V11.6A.791.791,0,0,0,13.111,10.8Zm0-8v.8H6.889V2.8a.778.778,0,1,0-1.556,0v.8H4.556A1.571,1.571,0,0,0,3.008,5.2L3,16.4A1.578,1.578,0,0,0,4.556,18H15.444A1.583,1.583,0,0,0,17,16.4V5.2a1.583,1.583,0,0,0-1.556-1.6h-.778V2.8a.778.778,0,1,0-1.556,0Zm1.556,13.6H5.333a.791.791,0,0,1-.778-.8v-8H15.444v8A.791.791,0,0,1,14.667,16.4Z",
    transform: "translate(-3 -2)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendarFest);
export default __webpack_public_path__ + "static/media/icon_calendar_fest.0a28793e071efaab71cd29ec16289e5f.svg";
export { ForwardRef as ReactComponent };